import { isWizardFlowPath } from '../utils/wizardCategoryRoute';
import { resolveLandingPath, UNAUTHORIZED_LANDING_PATH, type AccessContext } from './landingPage';
import { wasRoleJustSwitched } from './roleSwitchFlag';

/**
 * When the user switches roles while inside the create-case-request wizard, send them
 * to their new role's main menu instead of leaving them on the same wizard step.
 */
export function resolveRoleSwitchRedirect(pathname: string, ctx: AccessContext): string | null {
  if (!wasRoleJustSwitched() || !isWizardFlowPath(pathname)) return null;

  const target = resolveLandingPath(ctx);
  const normalized = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  if (target === UNAUTHORIZED_LANDING_PATH || target === normalized) return null;
  return target;
}
